/**
 * COMPONENT: GameUI
 * UI overlay per score, vite e informazioni di gioco
 */

import React from "react";
import { GameState } from "../types/GameTypes";

interface GameUIProps {
    score: number;
    lives: number;
    level: number;
    frightenedTimer: number;
    gameState: GameState;
    width: number;
}

export const GameUI: React.FC<GameUIProps> = ({
    score: _score,
    lives: _lives,
    level: _level,
    frightenedTimer,
    gameState,
    width: _width,
}) => {
    return (
        <>
            {/* Game info overlay */}
            <div className="absolute top-2 left-2 text-yellow-400 text-sm font-mono bg-black/50 rounded px-2 py-1">
                {gameState === "playing" && frightenedTimer > 0 && (
                    <div className="text-blue-400 animate-pulse">
                        Modalita power: {Math.ceil(frightenedTimer / 1000)}s
                    </div>
                )}
            </div>

            {/* Score and Lives - rendered on canvas via GameRenderer */}
        </>
    );
};
